import { StandardLayout } from '@sequencehq/core-components'
import { useState } from 'react'
import { DeferredRevenueDashboardHeader } from './DeferredRevenueDashboardHeader'
import { DeferredRevenueDashboardContent } from './content/DeferredRevenueDashboardContent'
import type { DeferredRevenueTableGroupBy } from './content/DeferredRevenueDashboardTable'

export type Control<T> = {
  value: T
  onChange: (next: T) => void
}

export const DeferredRevenueDashboard = () => {
  const [asOfDateValue, setAsOfDate] = useState<Date>(new Date())
  const [groupByValue, setGroupBy] =
    useState<DeferredRevenueTableGroupBy>('customer')

  const asOfDate: Control<Date> = {
    value: asOfDateValue,
    onChange: setAsOfDate
  }
  const groupBy: Control<DeferredRevenueTableGroupBy> = {
    value: groupByValue,
    onChange: setGroupBy
  }

  return (
    <StandardLayout
      header={
        <DeferredRevenueDashboardHeader
          asOfDate={asOfDate.value}
          groupBy={groupBy.value}
        />
      }
      content={
        <DeferredRevenueDashboardContent
          asOfDate={asOfDate}
          groupBy={groupBy}
        />
      }
    />
  )
}
